// blakfy-cookie/src/i18n/translations/ja.js — Japanese translations

export default {
  title: "Cookieの設定",
  intro:
    "このサイトはエクスペリエンスを向上させるためにCookieを使用します。詳細はCookieポリシーをご覧ください。",
  policyLink: "Cookieポリシー",
  acceptAll: "すべて承認",
  rejectAll: "すべて拒否",
  preferences: "設定",
  save: "選択を保存",
  close: "閉じる",
  cat: {
    essential: {
      title: "必須Cookie",
      desc: "サイトの基本機能に必要です。無効にできません。",
      always: "常に有効",
    },
    analytics: { title: "分析Cookie", desc: "匿名の訪問統計を収集するために使用されます。" },
    marketing: {
      title: "マーケティングCookie",
      desc: "パーソナライズされた広告とリターゲティングに使用されます。",
    },
    functional: {
      title: "機能Cookie",
      desc: "言語やテーマなどの設定を記憶するために使用されます。",
    },
  },
  placeholder: {
    title: "コンテンツがブロックされました",
    desc: "このコンテンツを表示するには{category}Cookieを許可する必要があります。",
    cta: "許可する",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
